export default {
  state: {
    maskLayers: [],
  },
  getters: {
    maskLayer(state) {
      return state.maskLayers.length > 0 ? 'auto' : 'none'
    },
  },
  mutations: {
    setMaskLayer(state, dialog) {
      if (dialog) state.maskLayers.push('a')
      else state.maskLayers.pop()
      const mainContent = document.getElementById('main-content')
      if (state.maskLayers.length > 0) {
        mainContent.classList.add('disable-interaction')
      } else {
        mainContent.classList.remove('disable-interaction')
      }
    },
  },
}
